module.exports = __webpack_public_path__ + "img/lan.f7776109.jpg";